"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = exports.timed = void 0;
const create_error_1 = require("../create-error");
const error_interfaces_1 = require("../types/error.interfaces");
// race a promise against a timeout
function timed(promise, globalContext, ms, errorReason = error_interfaces_1.ErrorReason.TimedOut) {
    let timeoutHandle;
    const timeoutPromise = new Promise((resolve) => {
        timeoutHandle = globalContext.setTimeout(resolve, ms);
    });
    return Promise.race([
        promise,
        timeoutPromise.then(() => {
            throw (0, create_error_1.createError)(errorReason);
        }),
    ]).then((result) => {
        globalContext.clearTimeout(timeoutHandle);
        return result;
    });
}
exports.timed = timed;
// sleep
function sleep(ms, globalContext) {
    return new Promise((resolve, reject) => {
        if (ms < 0) {
            reject((0, create_error_1.createError)(error_interfaces_1.ErrorReason.InvalidParameters));
        }
        else {
            let handle = 0;
            handle = globalContext.setTimeout(() => {
                globalContext.clearTimeout(handle);
                resolve();
            }, ms);
        }
    });
}
exports.sleep = sleep;
